import type { App } from "vue";
import type { TranslationOptions } from "@/i18n";

const i18nPlugin = {
    install: (app: App, options: TranslationOptions) => {
        app.provide("i18n", options);
    },
};

export { i18nPlugin };
